export enum OasisSubmissionMessageSeverityEnum {
  Fatal = 1,
  Warning = 2
}

export const OasisSubmissionMessageSeverityOptions = [
{ id: 1, label: 'Fatal' },
{ id: 2, label: 'Warning' }
];
